import * as Yup from 'yup';
import createDeviceFormModel from './createDeviceFormModel';

const {
  formField: {
    name,
    is_user_required,
    is_single_user,
    is_multi_user,
    users,
    all_users
  }
} = createDeviceFormModel;

const validationSchema = [
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [is_user_required.name]: Yup.boolean().required(`${is_user_required.requiredErrorMsg}`),
    [is_single_user.name]: Yup.boolean(),
    [is_multi_user.name]: Yup.boolean().test(
      'selection-required',
      'Debe seleccionar si es para un único usuario o múltiples',
      function(value) {
        const { [is_user_required.name]: isRequired, [is_single_user.name]: isSingle } = this.parent;
        if (isRequired) {
          return isSingle || value;
        }
        return true;
      }
    ),
    [users.name]: Yup.mixed().when([is_single_user.name, is_multi_user.name, all_users.name], {
      is: (isSingle: any, isMulti: any, isAll: any) => isSingle || (isMulti && !isAll),
      then: (schema) => schema.test('is-not-empty', `${users.requiredErrorMsg}`, (value: any) => {
        if (Array.isArray(value)) return value.length > 0;
        return value !== null && value !== undefined && value !== '';
      }).required(`${users.requiredErrorMsg}`),
      otherwise: (schema) => schema.notRequired()
    }),
    [all_users.name]: Yup.boolean()
  })
];

export default validationSchema;
